import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';
import _isEmpty from 'lodash/isEmpty';

import { USER_ROLE } from 'constants/logic';
import { dashboardUsersPropTypes } from 'constants/propTypes';
import Button from 'components/Button';
import { Card, CardTitle } from 'components/Card';
import Message from 'components/Message';
import StaffAccountItem from './StaffAccountItemContainer';

import './StaffAccountsCard.scss';

export const messages = {
  [USER_ROLE.OWNER]: defineMessages({
    label: {
      id: 'staff-accounts.card.owner.label',
      defaultMessage: 'Owners',
    },
    description: {
      id: 'staff-accounts.card.owner.description',
      defaultMessage:
        'Owners are able to view revenue data in addition to everything Managers & Front desk users can do.',
    },
    buttonText: { id: 'staff-accounts.card.owner.button-text', defaultMessage: 'Add owner' },
  }),
  [USER_ROLE.MANAGER]: defineMessages({
    label: {
      id: 'staff-accounts.card.manager.label',
      defaultMessage: 'Managers',
    },
    description: {
      id: 'staff-accounts.card.manager.description',
      defaultMessage:
        'Managers can modify spots and can view ratings & reviews, in addition to everything a Front desk user can do.',
    },
    buttonText: { id: 'staff-accounts.card.manager.button-text', defaultMessage: 'Add manager' },
  }),
  [USER_ROLE.FRONT_DESK]: defineMessages({
    label: {
      id: 'staff-accounts.card.front-desk.label',
      defaultMessage: 'Front Desks',
    },
    description: {
      id: 'staff-accounts.card.front-desk.description',
      defaultMessage:
        'Front desk users can view rosters, mark attendance, manage the schedule, and send a message to any users with an upcoming reservation.',
    },
    buttonText: { id: 'staff-accounts.card.front-desk.button-text', defaultMessage: 'Add front desk' },
  }),
};

const StaffAccountsCard = ({ accounts, accountType, user = {}, openModal }) => {
  const { userId: currentUserId } = user;
  return (
    <Card flush>
      <Message as={CardTitle} className="p-r" message={messages[accountType].label} />
      {!_isEmpty(accounts) &&
        accounts.map(({ userId, ...restAccount }) => (
          <StaffAccountItem key={userId} account={{ userId, ...restAccount }} currentUserId={currentUserId} />
        ))}
      <Message as="p" className="staff-accounts-card__description" message={messages[accountType].description} />
      <div className="staff-accounts-card__footer">
        <Message
          as={Button}
          onClick={openModal}
          styled="primary-outline"
          type={Button.TYPES.BUTTON}
          message={messages[accountType].buttonText}
        />
      </div>
    </Card>
  );
};

StaffAccountsCard.defaultProps = {
  accountType: USER_ROLE.OWNER,
};

StaffAccountsCard.propTypes = {
  accounts: dashboardUsersPropTypes,
  accountType: PropTypes.string,
  openModal: PropTypes.func,
  user: PropTypes.shape({
    userId: PropTypes.number,
    email: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
  }),
};

export default StaffAccountsCard;
